import React, { useState } from "react";
import RepurchaseSimulator from "./RepurchaseSimulator";

const RepurchaseSimulatorWidget = ({
  initialValues = {},
  onClose,
  defaultOpen = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(!defaultOpen);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1040,
        width: isCollapsed ? "auto" : 520,
        maxWidth: "calc(100vw - 40px)",
        background: "white",
        border: "1px solid #dee2e6",
        borderRadius: 8,
        boxShadow: "0 0.5rem 1.5rem rgba(0, 0, 0, 0.2)",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom"
        style={{
          cursor: "pointer",
          background: "#00458a",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          color: "white",
        }}
        onClick={() => setIsCollapsed((c) => !c)}
      >
        <strong>
          <i className="fa fa-calculator pr-2" />
          Simulateur de grille VR
        </strong>
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <button
            type="button"
            className="btn btn-sm btn-link bg-white p-0"
            onClick={(e) => {
              e.stopPropagation();
              setIsCollapsed((c) => !c);
            }}
            title={isCollapsed ? "Déplier" : "Replier"}
          >
            <i className={`fa fa-chevron-${isCollapsed ? "up" : "down"}`} />
          </button>
          {onClose && (
            <button
              type="button"
              className="btn btn-sm btn-link bg-white p-0 text-danger"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              title="Fermer"
            >
              <i className="fa fa-times" />
            </button>
          )}
        </div>
      </div>

      <div
        className="p-3"
        style={{ display: isCollapsed ? "none" : "block" }}
      >
        <RepurchaseSimulator initialValues={initialValues} />
      </div>
    </div>
  );
};

export default RepurchaseSimulatorWidget;
